import React from "react";
import driven from "../images/driven-series-poster.webp";
import drivenSmall from "../images/driven-series-poster-200.webp";
import drivenMedium from "../images/driven-series-poster-300.webp";
import pitchPlanet from "../images/pitch-planet-series-poster.webp";
import pitchPlanetSmall from "../images/pitch-planet-series-poster-200.webp";
import pitchPlanetMedium from "../images/pitch-planet-series-poster-300.webp";
import sheconomics from "../images/sheconomics-series-poster.webp";
import sheconomicsSmall from "../images/sheconomics-series-poster-200.webp";
import sheconomicsMedium from "../images/sheconomics-series-poster-300.webp";
import visionaries from "../images/visionaries-series-poster.webp";
import visionariesSmall from "../images/visionaries-series-poster-200.webp";
import visionariesMedium from "../images/visionaries-series-poster-300.webp";
import blackIsTheNewGreen from "../images/black-is-the-new-green-series-poster.webp";
import blackIsTheNewGreenSmall from "../images/black-is-the-new-green-series-poster-200.webp";
import blackIsTheNewGreenMedium from "../images/black-is-the-new-green-series-poster-300.webp";
import radivisionLive from "../images/radivision-live-series-poster.webp";
import radivisionLiveSmall from "../images/radivision-live-series-poster-200.webp";
import radivisionLiveMedium from "../images/radivision-live-series-poster-300.webp";
import howToNotGetFucked from "../images/how-to-not-get-fucked-series-poster.webp";
import howToNotGetFuckedSmall from "../images/how-to-not-get-fucked-series-poster-200.webp";
import howToNotGetFuckedMedium from "../images/how-to-not-get-fucked-series-poster-300.webp";
import unicornUnAwards from "../images/unicorn-un-awards-series-poster.webp";
import unicornUnAwardsSmall from "../images/unicorn-un-awards-series-poster-200.webp";
import unicornUnAwardsMedium from "../images/unicorn-un-awards-series-poster-300.webp";
import parachute from "../images/parachute-series-poster.webp";
import parachuteSmall from "../images/parachute-series-poster-200.webp";
import parachuteMedium from "../images/parachute-series-poster-300.webp";
import pitchTwitch from "../images/pitch-twitch-series-poster.webp";
import pitchTwitchSmall from "../images/pitch-twitch-series-poster-200.webp";
import pitchTwitchMedium from "../images/pitch-twitch-series-poster-300.webp";
import siliconValleySafari from "../images/silicon-valley-safari-series-poster.webp";
import siliconValleySafariSmall from "../images/silicon-valley-safari-series-poster-200.webp";
import siliconValleySafariMedium from "../images/silicon-valley-safari-series-poster-300.webp";
import entrepreneurialEvents from "../images/entrepreneurial-events-broadcasting-series-poster.webp";
import entrepreneurialEventsSmall from "../images/entrepreneurial-events-broadcasting-series-poster-200.webp";
import entrepreneurialEventsMedium from "../images/entrepreneurial-events-broadcasting-series-poster-300.webp";

const SERIES = [
  { src: driven, small: drivenSmall, medium: drivenMedium, alt: "Driven — Radivision original series" },
  { src: pitchPlanet, small: pitchPlanetSmall, medium: pitchPlanetMedium, alt: "Pitch Planet — Radivision original series" },
  { src: sheconomics, small: sheconomicsSmall, medium: sheconomicsMedium, alt: "SHEconomics — Radivision original series" },
  { src: visionaries, small: visionariesSmall, medium: visionariesMedium, alt: "Visionaries — Radivision original series" },
  { src: blackIsTheNewGreen, small: blackIsTheNewGreenSmall, medium: blackIsTheNewGreenMedium, alt: "Black Is The New Green — Radivision original series" },
  { src: radivisionLive, small: radivisionLiveSmall, medium: radivisionLiveMedium, alt: "Radivision Live — Meet The Radical Visionaries" },
  { src: howToNotGetFucked, small: howToNotGetFuckedSmall, medium: howToNotGetFuckedMedium, alt: "How To Not Get Fucked — Radivision original series" },
  { src: unicornUnAwards, small: unicornUnAwardsSmall, medium: unicornUnAwardsMedium, alt: "Unicorn Un-Awards — Radivision original series" },
  { src: parachute, small: parachuteSmall, medium: parachuteMedium, alt: "Parachute — Radivision original series" },
  { src: pitchTwitch, small: pitchTwitchSmall, medium: pitchTwitchMedium, alt: "Pitch Twitch — Radivision original series" },
  { src: siliconValleySafari, small: siliconValleySafariSmall, medium: siliconValleySafariMedium, alt: "Silicon Valley Safari — Radivision original series" },
  { src: entrepreneurialEvents, small: entrepreneurialEventsSmall, medium: entrepreneurialEventsMedium, alt: "Entrepreneurial Events Broadcasting — Radivision original series" },
];

const OriginalSeries = () => {
  return (
    <div>
      <section className="original-series-section">
        <div className="overlay-title">
          <h2 className="original-series-title">
            Watch Exclusive <br />
            Radivision Original Series
          </h2>
        </div>
        <div className="series-grid">
          {SERIES.map(({ src, small, medium, alt }) => (
            <div key={alt} className="series-item">
              {/* Phones (<=480px) show 4 posters per row at ~80-100px; other layouts cap them at 200px. The
                  browser picks the smallest file that covers that width at the screen's density (e.g. 200px
                  for 2x phones, 300px for 3x phones, 400px for 2x desktops). */}
              <img
                src={src}
                srcSet={`${small} 200w, ${medium} 300w, ${src} 400w`}
                sizes="(max-width: 480px) 100px, 200px"
                alt={alt}
                className="series-image"
                width={400}
                height={593}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </section>
      <div className="mission-content">
        <p className="mission-description">
          Radivision Originals pull back the curtain on the private startup ecosystem through unscripted series starring
          real founders and investors solving real startup challenges. Radivision also curates resources, user-generated
          content, expert advice, <em>Pitch Planet™</em> deal discovery, and more.
        </p>
      </div>
    </div>
  );
};

export default OriginalSeries;
